import tw from "tailwind-styled-components";
const BaseContainer = tw.div`
  inline-flex
  justify-center
  items-center
`;
export default BaseContainer;
